module.exports = __webpack_public_path__ + "static/media/proj20_img17.ef613162.jpg";